import * as THREE from 'three'
import { gsap } from 'gsap'
import Experience from '../Experience'
import EventEmitter from '../Utils/EventEmitter'
import StartButton from '../UI/StartButton'
import vertex_0 from './Shader/0_FadeOutSimple/vertex_0.glsl'
import fragment_0 from './Shader/0_FadeOutSimple/fragment_0.glsl'
import vertex_1 from './Shader/1_FadeOutCircle/vertex_1.glsl'
import fragment_1 from './Shader/1_FadeOutCircle/fragment_1.glsl'
import vertex_2 from './Shader/2_FadeOutGradient/vertex_2.glsl'
import fragment_2 from './Shader/2_FadeOutGradient/fragment_2.glsl'

export default class LoadingScreen extends EventEmitter
{
  constructor() {
    super()
    this.loadBarElement = document.querySelector('.loading_bar')
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;

    // StartButtonコンポーネントを初期化
    this.startButton = new StartButton()
    this.setupStartButtonEvents()

    this.overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1)
    this.overlayMaterial = new THREE.ShaderMaterial({
      transparent: true,
      depthWrite: false,
      depthTest: false,
      uniforms:
      {
          uAlpha: { value: 1.0 },
          uProgress: { value: 0.0 }
      },
      vertexShader: vertex_2,
      fragmentShader: fragment_2
  })

  this.overlay = new THREE.Mesh(this.overlayGeometry, this.overlayMaterial)
  this.overlay.renderOrder = 10
  this.overlay.frustumCulled = false // フラスタムカリングを無効
  this.scene.add(this.overlay);

  this.resources.on('progress', () => {
    this.loadBarElement.style.transform  = `scaleX(${this.resources.progress})`
  })

  this.resources.on('ready', () => {
    gsap.delayedCall(0.5, () => {
        // ロード完了後スタートボタンを表示
        this.startButton.show()

        this.loadBarElement.classList.add('ended')
        this.loadBarElement.style.transform = ''
    })
  })
  }

  setupStartButtonEvents() {
    this.startButton.on('click', () => {
      gsap.to(this.overlayMaterial.uniforms.uProgress, {
        duration: 1.0,
        value: 1.0,
        ease: "power2.in",
        onComplete: () => {
          this.trigger('completed')
          this.scene.remove(this.overlay)
        }
      })
    })
  }
}